import React from 'react';
import { Link } from 'react-router-dom';

function Secao({ titulo, children }) {
  return (
    <section className="mb-8">
      <h2 className="text-xl font-bold text-navy mb-3">{titulo}</h2>
      <div className="text-gray-700 leading-relaxed space-y-3 text-[16px]">
        {children}
      </div>
    </section>
  );
}

export default function PoliticaPrivacidade() {
  return (
    <div className="max-w-3xl mx-auto px-6 pt-28 pb-16">
      <h1 className="text-3xl md:text-4xl font-bold text-navy mb-2 text-center">
        Política de Privacidade
      </h1>
      <p className="text-sm text-gray-500 text-center mb-10">
        Última atualização: junho de 2026
      </p>

      <Secao titulo="1. Quem somos">
        <p>
          A <strong>Associação dos Engenheiros Agrônomos de Goiás (AEAGO)</strong>, pessoa jurídica
          de direito privado, sem fins lucrativos, com sede em Goiânia/GO, é a responsável por este
          site institucional.
        </p>
      </Secao>

      <Secao titulo="2. Coleta de dados pessoais">
        <p>
          Este site é estritamente informativo. <strong>Não coletamos, armazenamos nem tratamos
          dados pessoais</strong> dos visitantes. Não há formulários de cadastro, contato ou
          associação neste site.
        </p>
      </Secao>

      <Secao titulo="3. Dados de navegação">
        <p>
          Durante a visita ao site, o seu próprio navegador e a infraestrutura de hospedagem podem
          registrar automaticamente dados técnicos de navegação, como endereço IP, tipo de
          navegador, sistema operacional e páginas acessadas. Esse registro ocorre nos servidores de
          hospedagem por razões operacionais e de segurança, e está fora do controle direto da
          AEAGO.
        </p>
        <p>
          A AEAGO não acessa, utiliza nem compartilha esses dados para nenhuma finalidade.
        </p>
      </Secao>

      <Secao titulo="4. Cookies">
        <p>
          Cookies são pequenos arquivos armazenados no seu dispositivo pelo navegador. Este site
          utiliza apenas um cookie de preferência para registrar sua escolha no banner de cookies,
          evitando que ele reapareça a cada visita. Esse cookie não contém dados pessoais e não é
          compartilhado com terceiros.
        </p>
        <p>
          Você pode configurar seu navegador para bloquear ou excluir cookies a qualquer momento
          sem prejuízo ao uso do site.
        </p>
      </Secao>

      <Secao titulo="5. Links externos">
        <p>
          Este site pode conter links para sites de terceiros (redes sociais, portais de notícias,
          etc.). A AEAGO não se responsabiliza pelas práticas de privacidade desses sites, e
          recomendamos que você consulte as políticas de privacidade de cada um deles.
        </p>
      </Secao>

      <Secao titulo="6. Alterações nesta política">
        <p>
          Esta política pode ser atualizada periodicamente para refletir mudanças no site. A data
          da última atualização consta no topo desta página.
        </p>
      </Secao>

      <Secao titulo="7. Contato">
        <p>
          Em caso de dúvidas sobre esta política, entre em contato com a AEAGO pelo e-mail{' '}
          <a href="mailto:contato@aeago.org.br" className="text-secondary hover:underline">
            contato@aeago.org.br
          </a>
          .
        </p>
      </Secao>

      <div className="mt-10 border-t border-gray-200 pt-6 text-center">
        <Link
          to="/"
          className="inline-flex items-center text-navy hover:underline font-medium"
        >
          ← Voltar ao início
        </Link>
      </div>
    </div>
  );
}
